module.exports = __webpack_public_path__ + "img/Deck V1.a895bd71.jpg";